import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-dlg-filters',
  templateUrl: './dlg-filters.component.html',
  styleUrls: ['./dlg-filters.component.scss']
})
export class DlgFiltersComponent implements OnInit {
  grupoVal = new FormGroup({
    agencia: new FormControl('', Validators.required),
    provincia: new FormControl('', Validators.required),
  });
  agencias: any = [];
  provincias: any = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<DlgFiltersComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }

  async ngOnInit() {
    if (this.data.operacion == 'Editar') {
      this.getProvincias();
      this.loadAgencias();
      this.gateway.get('agenciascampana', { IDCAMPANA: this.data.campana.idcampana }).then((result: any) => {
        const agencias = result.map(element => element.id);
        this.grupoVal.controls.agencia.setValue(agencias);
      }
      ).catch(function (e) { });

      this.gateway.get('provinciascampana', { IDCAMPANA: this.data.campana.idcampana }).then((result: any) => {
        const provincias = result.map(element => element.idprovincia);
        this.grupoVal.controls.provincia.setValue(provincias);
      }
      ).catch(function (e) { });
    }
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.provincias = aux.rows;
    }
    ).catch(function (e) {
    });
  }

  loadAgencias() {
    this.gateway.get('getagencias', { IDCAMPANA: this.data.campana.idcampana }).then((result: any) => {
      // console.log(result);
      this.agencias = result;
    }
    ).catch(function (e) {
    });
  }

  getError(type) {
    if (type == 1) {
      if (this.grupoVal.controls.agencia.hasError('required')) {
        return 'Debes seleccionar una agencia.';
      }
    }
    else if (type == 2) {
      if (this.grupoVal.controls.provincia.hasError('required')) {
        return 'Debes seleccionar una provincia.';
      }
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let datos = {
      ...this.data.campana,
      IDCAMPANA: this.data.campana.idcampana,
      IDUSUARIO: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,
      AGENCIAS: this.grupoVal.controls.agencia.value,
      PROVINCIAS: this.grupoVal.controls.provincia.value,
    };

    this.spinner.show();
    this.gateway.save('editarfiltrodistclientes', datos).then((result) => {
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }
}
